var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F0B90A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8558 10.0108L11.7128 14.1536L9.30228 11.7429L15.8558 5.18913L22.4115 11.7451L20.0008 14.1557L15.8558 10.0108ZM7.60003 13.4447L5.18929 15.8555L7.59989 18.266L10.0106 15.8553L7.60003 13.4447ZM11.7128 17.558L15.8558 21.7008L20.0007 17.556L22.4126 19.9653L22.4115 19.9666L15.8558 26.5225L9.30206 19.9689L9.29865 19.9655L11.7128 17.558ZM24.112 13.4461L21.7013 15.8568L24.1119 18.2674L26.5226 15.8566L24.112 13.4461Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2835 15.9987H18.2845L15.9999 13.7142L14.3115 15.4025H14.3114L14.1175 15.5966L13.7174 15.9967L13.7142 15.9998L13.7174 16.0031L15.9999 18.2856L18.2845 16.0011L18.2856 15.9998L18.2835 15.9987",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.0f1e362979e881cb8e519cf8ffd5ea29.svg";
export { ForwardRef as ReactComponent };